// Filtro por valor: faixa de preco (min/max) e desconto minimo. Quando o dado
// necessario nao existe na mensagem, a acao configurada decide (passar/descartar).
const PASS = { pass: true };
function reject(reason) {
    return { pass: false, reason };
}
function checkPrice(filter, price) {
    if (filter.minPriceCents === null && filter.maxPriceCents === null) {
        return PASS;
    }
    if (price === null) {
        return filter.priceUnknownAction === "drop" ? reject("price_unknown") : PASS;
    }
    if (filter.minPriceCents !== null && price < filter.minPriceCents) {
        return reject("below_min_price");
    }
    if (filter.maxPriceCents !== null && price > filter.maxPriceCents) {
        return reject("above_max_price");
    }
    return PASS;
}
function checkDiscount(filter, discount) {
    if (filter.minDiscountPercent === null) {
        return PASS;
    }
    if (discount === null) {
        return filter.priceUnknownAction === "drop" ? reject("discount_unknown") : PASS;
    }
    return discount < filter.minDiscountPercent ? reject("below_min_discount") : PASS;
}
export function evaluateValueFilter(filter, offer) {
    if (!filter.enabled) {
        return PASS;
    }
    const price = checkPrice(filter, offer.priceCents);
    return price.pass ? checkDiscount(filter, offer.discountPercent) : price;
}
//# sourceMappingURL=value-filter.js.map